import { SearchStates } from '../states';

export const selectBasicSearch = (state: SearchStates) => state.search.basicSearch;
export const selectBranches = (state: SearchStates) => state.search.branches;
export const selectLocationsFrom = (state: SearchStates) => state.search.locationsFrom;
export const selectLocationsTo = (state: SearchStates) => state.search.locationsTo;
export const selectCustomers = (state: SearchStates) => state.search.customers;
export const selectSuppliers = (state: SearchStates) => state.search.suppliers;



